import styled from 'styled-components';
import { StyledCustomSelectorProps } from './CustomSelector.types';

export const StyledCustomSelector = styled.button<StyledCustomSelectorProps>`
  cursor: pointer;

  ${(props) => props.customStyle}
`;
